import FactStatusBadge from "@/components/hfacs/FactStatusBadge";

export default function MeetingTimelineView({ facts }) {
  if (facts.length === 0) {
    return <p className="text-lg text-muted-foreground text-center py-20">Aucun fait relevé pour l'instant.</p>;
  }
  return (
    <div className="space-y-4 max-w-4xl mx-auto" data-testid="meeting-timeline-list">
      {facts.map((f) => (
        <div key={f.ID_FAIT} data-testid={`meeting-fact-row-${f.ID_FAIT}`} className="bg-card border border-border rounded-md p-5">
          <div className="flex items-center justify-between gap-3 mb-2">
            <span className="font-mono text-sm text-muted-foreground">{f.DATE} {f.HEURE}</span>
            <FactStatusBadge status={f.STATUT_VERIFICATION} />
          </div>
          <p className="text-lg leading-relaxed">{f.DESCRIPTION_FACTUELLE}</p>
          {f.SOURCE && <p className="text-sm text-muted-foreground mt-2">Source : {f.SOURCE} {f.FONCTION_SOURCE && `(${f.FONCTION_SOURCE})`}</p>}
        </div>
      ))}
    </div>
  );
}
